import React, { useMemo } from 'react'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import { Link, Outlet, useParams } from 'react-router-dom'

import Button from '../../components/basics/Button/Button'
import CommentsList from '../../components/comments/CommentsList/CommentsList'
import { useLearningItem } from '../../state/entities'
import useRoutes from '../../state/useRoutes'

import styles from './CourseCommentPage.module.scss'

/**********************************************************************
 * CourseCommentPage
 **********************************************************************/
export default React.memo(function CourseCommentPage() {
  const { t } = useTranslation()
  const routes = useRoutes()

  const { uuid, commentUuid } = useParams()

  const { learningItem } = useLearningItem(uuid)
  const rootUuid = useMemo(() => ({ learningItemUuid: uuid! }), [uuid])

  return (
    <>
      <article className={classnames(styles.CourseCommentPage, { skeleton: learningItem.isDummy })}>
        <header>
          <h1>{learningItem.title}</h1>
          <Button small component={Link} to={routes.course.url({ uuid: uuid! })}>
            {t('learning item.cta back to course page')}
          </Button>
        </header>

        <main>
          <CommentsList commentUuid={commentUuid!} rootUuid={rootUuid} root={learningItem} />
        </main>
      </article>
      <Outlet />
    </>
  )
})

/**********************************************************************
 * CourseCommentPageBreadcrumb
 **********************************************************************/
export function CourseCommentPageBreadcrumb() {
  const { t } = useTranslation()
  const { uuid, commentUuid } = useParams()
  const routes = useRoutes()
  return (
    <Link to={routes.courseComment.url({ uuid: uuid!, commentUuid: commentUuid! })}>{t('comment.field comments')}</Link>
  )
}
